import React from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link } from 'react-router-dom'
import CreateUserForm from '../../components/userAndGroupForms/CreateUserForm/CreateUserForm'
import useRoutes from '../../state/useRoutes'

export default React.memo(function CreateUserPage() {
  const { close } = useOutletContext<any>()

  return <CreateUserForm onClose={close} />
})

export function CreateUserPageBreadcrumb() {
  const { t } = useTranslation()
  const routes = useRoutes()
  return <Link to={routes.createUser.url({})}>{t('manage user.create user')}</Link>
}
